<!-- 未登录展示 -->
<template>
  <div class="not-login">
    <BaseEmpty v-bind="$attrs" btnText="立即登录" @btnClick="handleLogin" />

    <!-- 登录弹框 -->
    <LoginDialog ref="LoginDialogRef" @close="hanleLoginDialogClose" />
  </div>
</template>

<script>
// 登录弹框
import LoginDialog from '@@/components/loginDialog/index'

// PCB下单页 登录之前缓存参数的key
export const QUOTE_BEFORE_LOGIN_PCB_PARAMS_SESSION_KEY = 'QUOTE_BEFORE_LOGIN_PCB_PARAMS_SESSION_KEY'

// 设置暂存的PCB参数
export const setBefoerLoginPcbParams = (params) => {
  try {
    sessionStorage.setItem(QUOTE_BEFORE_LOGIN_PCB_PARAMS_SESSION_KEY, JSON.stringify(params))
  } catch (error) {}
}
// 获取暂存的PCB参数
export const getBefoerLoginPcbParams = () => {
  try {
    return sessionStorage.getItem(QUOTE_BEFORE_LOGIN_PCB_PARAMS_SESSION_KEY)
  } catch (error) {
    return null
  }
}
// 删除暂存的PCB参数
export const removeBefoerLoginPcbParams = () => {
  try {
    sessionStorage.removeItem(QUOTE_BEFORE_LOGIN_PCB_PARAMS_SESSION_KEY)
  } catch (error) {}
}

export default {
  components: {
    LoginDialog
  },
  // 来源：pcbQuote/index.vue
  inject: {
    pcbParams: { default: {} },
  },
  data() {
    return {

    }
  },
  methods: {
    // 暂存PCB参数
    cacheParams() {
      setBefoerLoginPcbParams(this.pcbParams)
    },
    // 打开登录弹框
    handleLogin(type = 0) {
      // 先暂存PCB参数
      this.cacheParams()
      this.$refs.LoginDialogRef.open(type)
    },
    hanleLoginDialogClose() {
      removeBefoerLoginPcbParams()
    }
  }
}
</script>

<style lang="scss" scoped>
</style>